var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{staticClass:"page-up",attrs:{"placement":"top","content":"回到顶部"}},[_c('back-to-top',{staticClass:"icon-top",attrs:{"custom-style":_vm.backToTopStyle,"visibility-height":300,"back-position":0,"transition-name":"fade"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }